"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const addressUtils_1 = require("./addressUtils");
const extractIndicatif = (street) => {
    const regex = /(bis|ter|quater|b|c|t|q|quinquies)(?:\s)/;
    try {
        const res = regex.exec(street);
        if (!res)
            throw new Error('Unsupported address format!');
        // res = [Full match, Group 1]. We want to retrieve the first group
        const [, indicatif] = res;
        switch (indicatif.toLowerCase()) {
            case 'bis':
            case 'b':
                return addressUtils_1.INDICATIF_STREET.bis;
            case 'ter':
            case 't':
                return addressUtils_1.INDICATIF_STREET.ter;
            case 'quater':
            case 'q':
                return addressUtils_1.INDICATIF_STREET.quater;
            case 'c':
            case 'quinquies':
                return addressUtils_1.INDICATIF_STREET.quinquies;
            default:
                return '';
        }
    }
    catch (e) {
        return '';
    }
};
const extractStreetNumber = (street) => {
    const regex = /^\s*\d{0,3}/;
    try {
        const res = regex.exec(street);
        if (!res)
            throw new Error('Unsupported address format!');
        const [streetNumber] = res;
        return streetNumber;
    }
    catch (error) {
        return '';
    }
};
const extractStreetType = (street) => {
    const regex = /(Allée|ALL|Appartement|Arcade|Arrondissement|Atelier|Autoroute|Avenue|AVE|AV|Bas|Bâtiment|Berge|Boîte postale|BP|Boulevard|BD|Chemin|CHE|Cité|Corniche|Cours|CRS|Domaine|Escalier|Esplanade|Etage|Faubourg|FG|Immeuble|IMM|Impasse|IMP|Lieu-dit|LD|Lotissement|LOT|Parc|Passage|PAS|Place|PL|Promenade|PRO|Quai|Quartier|Résidence|RES|Rond point|RPT|Route|RTE|Rue|Ruelle|RLE|Square|SQ|Tour|Villa|Zone)/;
    try {
        const res = regex.exec(street);
        if (!res)
            throw new Error('Unsupported address format!');
        const [streetType] = res;
        const matchingStreetTypes = Object.entries(addressUtils_1.STREET_TYPES).find(([, types]) => types
            .map((type) => type.toLowerCase())
            .includes(streetType.toLowerCase()));
        if (matchingStreetTypes) {
            return matchingStreetTypes[0];
        }
        return streetType;
    }
    catch (error) {
        return '';
    }
};
/**
 * @see https://geo.api.gouv.fr/adresse
 */
const parseStreetAddress = async ({ city, country, street, zip, }) => {
    if (!addressUtils_1.isFrance(country)) {
        throw new Error('Addresses outside of France are not supported');
    }
    try {
        const gouv = await axios_1.default.get(`https://api-adresse.data.gouv.fr/search/?q=${street}&postcode=${zip}`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const { data: { features }, } = gouv;
        const [firstGouvResult] = features;
        const { properties: { locality, name, street: streetGouv }, } = firstGouvResult;
        const streetRes = streetGouv || locality || name;
        const indicatifStreet = extractIndicatif(name);
        const streetNumberWithoutIndicatif = extractStreetNumber(name);
        const streetType = extractStreetType(streetRes);
        return {
            city,
            indicatifStreet,
            streetName: streetRes.substring(streetType ? streetType.length + 1 : 0),
            streetNumber: streetNumberWithoutIndicatif,
            streetType,
            zip,
        };
    }
    catch (error) {
        return null;
    }
};
exports.default = parseStreetAddress;
